export default __webpack_public_path__ + "static/media/2012.9e618954.png";